import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import moment, { Moment } from 'moment';
import React from 'react';

const formatDate = {
  DD_MM_YYYY_HH_MM_SS: 'DD/MM/YYYY HH:mm:ss',
};

type TFormatKey = keyof typeof formatDate;

type TTooltipDate = {
  prefix?: string | React.ReactNode;
  prefix_tooltip?: string;
  date?: string | number | Moment;
  format: TFormatKey;
  tooltipProps?: TooltipProps;
  content?: string;
};

const TooltipDate = (props: TTooltipDate) => {
  const momentJsDate = props.date ? moment(props.date) : undefined;

  if (momentJsDate && momentJsDate.isValid()) {
    return (
      <Tooltip
        {...props.tooltipProps}
        title={`${props.prefix_tooltip || ''} ${moment(props.date).format(formatDate[props.format])}`}
      >
        {props.prefix} {props?.content || moment(props.date).fromNow()}
      </Tooltip>
    );
  } else {
    return <>--/--</>;
  }
};

export default TooltipDate;
